<template>
    <performance-common-dialog
        :title="title"
        ref="performanceCommonDialog"
        @close="dialogClose"
        :width="'1300px'"
    >
        <template #top>
            <el-form
                class="form-container"
                ref="formRef"
                label-position="right"
                :model="config.form"
                label-width="100px"
            >
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="分公司名称：" prop="companyName">
                            <span>{{ stationArriveInfo.companyName }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="平台名称：" prop="siteName">
                            <span>{{ stationArriveInfo.siteName }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="发车单号：" prop="dispatchNo">
                            <span>{{ stationArriveInfo.dispatchNo }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="承运商名称：" prop="carrierName">
                            <span>{{ stationArriveInfo.carrierName }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="实际车牌号：" prop="vehicleCard">
                            <span>{{ stationArriveInfo.vehicleCard }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            label="实际车型名称："
                            prop="equipmentName"
                        >
                            <span>{{ stationArriveInfo.equipmentName }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="司机名称：" prop="driver">
                            <span>{{ stationArriveInfo.driver }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            label="司机联系方式："
                            prop="driverContactWay"
                        >
                            <span>{{ stationArriveInfo.driverContactWay }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="发车时间：" prop="dispatchTime">
                            <span>{{ stationArriveInfo.dispatchTime }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </template>
        <template #table-list>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane
                    :label="item.label"
                    :name="item.name"
                    v-for="(item, index) in tabSList"
                    :key="index"
                >
                    <span slot="label">
                        {{ item.label }}
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="在货站明细进行运抵确认时，该货站所有的运输单号将批量运抵"
                            placement="top"
                        >
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </span>
                    <dispatch-ship-to-table
                        v-if="activeName === item.name"
                        :config="config"
                        :rowData="rowData"
                        :dictData="dictData"
                        :activeName="activeName"
                    ></dispatch-ship-to-table>
                </el-tab-pane>
            </el-tabs>
        </template>
    </performance-common-dialog>
</template>
<script>
import { siteConfig, tabSList } from './config.js';
import PerformanceCommonDialog from './PerformanceCommonDialog';
import DispatchShipToTable from './DispatchShipToTable';

export default {
    name: 'dispatchOrder',
    components: { PerformanceCommonDialog, DispatchShipToTable },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        rowData: {
            type: Object,
            default () {
                return {};
            }
        },
        stationArriveInfo: {
            type: Object,
            default () {
                return {};
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            title: '抵达货站',
            config: siteConfig,
            activeName: 'siteDetails',
            tabSList: tabSList
        };
    },
    methods: {
        // 切换tab类型
        handleClick (item) { },
        dialogClose () {
            this.$emit('handleClose', 'dispatchShipTo');
        }
    },
    mounted () {
        this.title = `抵达货站（任务单号：${this.rowData.taskNo}）`;
        this.$refs.performanceCommonDialog.show();
    }

};
</script>

<style scoped lang="less">
/deep/.el-form-item {
    margin: 0;
    .el-form-item__label {
        padding: 0;
    }
}
/deep/.el-tabs__header {
    margin-bottom: 0px;
}
/deep/.el-form-item__label {
    color: #999;
}
/deep/.el-form-item__content {
    color: #333;
}
.tms-performance-dialog .main-list-info {
    margin-top: 0px;
    padding-top: 0px;
}
</style>
